import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={30}
    height={30}
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect 
    x={0.5} 
    y={0.5} 
    width={29} 
    height={29} 
    rx={5.5} 
    fill={props.bgcolor}
    stroke="#947550" />
    <path
      d="M21.8184 8.15456C21.5041 8.10474 20.5202 8.22875 18.3268 7.83992C16.5756 7.52936 15.0001 7 15.0001 7C15.0001 7 13.9676 7.49462 11.9293 7.83992C9.39269 8.2694 8.18156 8.15456 8.18156 8.15456C8.18156 8.15456 7.49108 16.1048 8.8032 18.7282C9.81029 20.7418 14.0823 22.3571 14.9998 22.6914C15.9174 22.3572 20.1897 20.7421 21.1968 18.7282C22.509 16.1044 21.8184 8.15456 21.8184 8.15456H21.8184ZM19.8909 17.9566C19.0959 19.546 15.7244 20.8204 15.0001 21.0843C14.2758 20.8204 10.9044 19.5459 10.1097 17.9565C9.0736 15.8858 9.61869 9.61129 9.61869 9.61129L14.9998 8.67199L20.3816 9.61129C20.3816 9.61142 20.9267 15.8861 19.8909 17.9568V17.9566Z"
      fill={props.color}
    />
    <path
      d="M15.0002 9.28027C15.0002 9.28027 14.448 20.1378 15.0003 20.4103C15.6487 20.1742 18.6668 19.0335 19.3783 17.6106C20.305 15.7576 19.8174 10.1407 19.8174 10.1407L15.0002 9.28027Z"
      fill={props.color}
    />
  </svg>
);
export default SVGComponent;
